import React, { useState, useCallback } from 'react'
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types'
import SydButton from '../../../../../../../commonDesign/Button'
import SydModalActions from '../../../../../../../commonDesign/SydModal/SydModalActions'
import SydLabel from '../../../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../../../commonDesign/SydInput'
import SydSelect from '../../../../../../../commonDesign/SydSelect'

const presentationTypes = [
  { label: 'Data Grid', value: 'Data Grid' },
  { label: 'Presentation Table', value: 'Presentation Table' }
]

function generateLocalStorageKey () {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < 32; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

function AddPresentationForm ({ onCancel, onComplete }) {
  const [optionCode, setOptionCode] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [type, setType] = useState('Data Grid')
  const [description, setDescription] = useState('')
  const [error, setError] = useState(null)

  const isValid = optionCode.trim() && displayName.trim() && /^[a-z0-9-]+$/.test(optionCode.trim())

  const handleCreate = useCallback(() => {
    if (!isValid) return

    const codeValue = optionCode.trim()
    if (!/^[a-z0-9-]+$/.test(codeValue)) {
      setError('Option code must be lowercase letters, numbers, and hyphens only')
      return
    }

    setError(null)

    const newOption = {
      displayName: displayName.trim(),
      description: description.trim() || null,
      type,
      config: {
        purposeCode: null,
        columns: [],
        footerPurposeCode: null,
        footerColumnMapping: [],
        defaultSort: [],
        localStorageKey: generateLocalStorageKey(),
        variationGroups: ['default']
      }
    }

    onComplete({ optionCode: codeValue, optionData: newOption })
  }, [optionCode, displayName, type, description, isValid, onComplete])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <SydLabel required label='Option Code' helperText='Lowercase, numbers, hyphens (e.g., default-grid)'>
          <SydInput
            value={optionCode}
            onChange={(e) => setOptionCode(e.target.value)}
            placeholder='default-grid'
          />
        </SydLabel>
      </Grid>

      <Grid item xs={12} md={6}>
        <SydLabel required label='Display Name' helperText='Human-readable name'>
          <SydInput
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder='Default Data Grid'
          />
        </SydLabel>
      </Grid>

      <Grid item xs={12}>
        <SydLabel required label='Presentation Type'>
          <SydSelect
            options={presentationTypes}
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
        </SydLabel>
      </Grid>

      <Grid item xs={12}>
        <SydLabel label='Description' helperText='Optional description of this presentation'>
          <SydInput
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={2}
            placeholder='Standard data grid with paging and filtering'
          />
        </SydLabel>
      </Grid>

      <Grid item xs={12}>
        {error ? <div style={{ color: 'red', marginBottom: '8px' }}>{error}</div> : null}
        <SydModalActions>
          <SydButton variant='ghost' size='md' onClick={onCancel}>
            Cancel
          </SydButton>
          <SydButton
            disabled={!isValid}
            variant='primary'
            size='md'
            onClick={handleCreate}
          >
            Create Presentation
          </SydButton>
        </SydModalActions>
      </Grid>
    </Grid>
  )
}

AddPresentationForm.propTypes = {
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default AddPresentationForm
